/**
 * openActivityPortal (activityPortal.js) with this tab's workspace and Run As filled in: the one
 * call the form hosts make (FTSQuickView, FTSDetailViewForm, FTSListViewForm). Synchronous, so
 * the hosts call it straight from the click, before any await.
 */
import { clientStore } from "../store/clientStore";
import { authorizationStore } from "../store/authorizationStore";
import { openActivityPortal } from "./activityPortal";

/**
 * @param {object} activity  { id, portalId }
 * @param {object} ctx       { moduleId, entries | entryIds, routeName, onReturn }
 * @returns {boolean} true when the portal page opened instead of the form
 */
export function openActivityPortalHere(activity, ctx) {
  return openActivityPortal(activity, {
    ...(ctx || {}),
    workspace: clientStore.state.workspace,
    runAs: Boolean(authorizationStore.getters.isRunAs),
  });
}

export default { openActivityPortalHere };
